import ReactMarkdown from "react-markdown";

const PROSE =
  "text-sm leading-relaxed text-muted-foreground space-y-2 " +
  "[&_h1]:text-lg [&_h1]:font-bold [&_h1]:text-foreground [&_h1]:mt-2 " +
  "[&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-foreground " +
  "[&_h3]:font-semibold [&_h3]:text-foreground " +
  "[&_strong]:font-semibold [&_strong]:text-foreground " +
  "[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 " +
  "[&_a]:text-primary [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:border-primary/40 [&_blockquote]:pl-3 [&_blockquote]:italic";

export function RichText({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={`${PROSE} ${className}`}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
